import { gql, useQuery } from "@apollo/client"
import { Company } from "@oysterhr/schema"

const CARTA_SYNC_ERRORS_QUERY = gql`
  query CartaSyncErrorsQuery($companyId: ID!) {
    company(companyId: $companyId) {
      cartaSyncErrors {
        id
        syncedAtDate
        engagement {
          id
          teamMemberName
          countryCode
          teamMember {
            avatarUrl
          }
        }
      }
    }
  }
`

export const useCartaSyncErrors = (companyId: string, query?: string) => {
  return useQuery<{ company: Company }>(CARTA_SYNC_ERRORS_QUERY, {
    variables: { companyId, query },
  })
}
